import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ScheduledIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M4.88568 3.85714L4.88569 0.771429M13.1143 3.85714L13.1143 0.771429M0.771429 7.97143L0.771435 16.2C0.771436 16.7681 1.23194 17.2286 1.80001 17.2286H16.2C16.7681 17.2286 17.2286 16.7681 17.2286 16.2L17.2286 7.97143M0.771429 7.97143V4.88571C0.771429 4.31765 1.23194 3.85714 1.8 3.85714H16.2C16.7681 3.85714 17.2286 4.31765 17.2286 4.88571L17.2286 7.97143M0.771429 7.97143H17.2286M5.91429 12.0857L8.48571 14.6571L12.6 10.5429" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

ScheduledIcon.displayName = 'ScheduledIcon';
